import React, { useMemo } from 'react';

// LOCAL PARTS
import { BarChart, LineChart, PieChart } from '../charts/Chart';

// STYLES
import styles from './dataChart.module.scss';

// MAIN COMPONENT
const DataChart = ({
  chartReport: {
    chart_type_code, //
    chart_title,
    chart_subtitle,
    isStacked
  } = {},
  chartData,
  dataFormat,
  axisFormat,
  showTitle
}) => {

  // CHILD COMPONENTS
  const ChartMemo = useMemo(
    () => ({
      'h-bar-chart': BarChart,
      'v-bar-chart': BarChart,
      'line-chart':  LineChart,
      'pie-chart':   PieChart
    }[chart_type_code]),
    [chart_type_code]
  )

  // RENDER
  return (
    <div className={styles.chart}>
      {showTitle &&
        <>
          {chart_title && <h3>{chart_title}</h3>}
          {chart_subtitle && <h4 className="text-gray-600">{chart_subtitle}</h4>}
        </>
      }
      {ChartMemo &&
        <ChartMemo
          data={chartData}
          dataFormat={dataFormat}
          axisFormat={axisFormat}
          direction={chart_type_code === 'v-bar-chart' ? 'horizontal' : 'vertical'}
          isStacked={isStacked}
        />
      }
    </div>
  );
};

// EXPORT
export default DataChart;
